import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=a6b804da&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=a6b804da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b804da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6b804da')) {
      api.createRecord('a6b804da', component.options)
    } else {
      api.reload('a6b804da', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=a6b804da&scoped=true&", function () {
      api.rerender('a6b804da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ndmIV0VK7z4x/JS/comp/Voucher.vue"
export default component.exports